import {
  IImageData,
  IKenBurnsParam,
  IOwnedBy,
  IResponse,
  IStatus,
  IThumbnail,
} from '../interfaces';

interface IPreviewParam {
  breadth: number;
  centerX: number;
  centerY: number;
}

interface IPreview {
  title: string;
  uid: string;
  averageColor: string;
  kenBurnsParams: Record<string, IKenBurnsParam>;
  images: IImageData[];
  ownedBy: Partial<IOwnedBy>;
  suggestive?: number;
  previewParams: Record<any, IPreviewParam>;
  thumbnails: IThumbnail[];
  updatedAt: string;
}

export interface IInterest {
  name: Record<string, string>;
  description?: Record<string, string>;
  previews?: IPreview[];
  priority: number;
  uid: string;
}

export interface IInterestResponse extends IResponse {
  interests: IInterest[];
  status: IStatus;
  gen: string;
  ttl: string;
}

export class EnhancedInterestResponse implements IInterestResponse {
  interests: IInterest[];
  status: IStatus;
  gen: string;
  ttl: string;

  mapped: Map<string, IInterest> = new Map<string, IInterest>();

  constructor(data: IInterestResponse) {
    this.interests = data.interests;
    this.status = data.status;
    this.gen = data.gen;
    this.ttl = data.ttl;
    this.mapped = this.asMap()
  }

  asMap = () => {
    const out = new Map<string, IInterest>();
    for (const interest of this.interests) {
      out.set(interest.uid, interest);
    }
    return out
  }

  interestForId(id: string) {
    return this.mapped.get(id)
  }

}
